import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Label, Col } from 'reactstrap';
import './App.css';

// https://css-tricks.com/intro-firebase-react/
class Logout extends Component {
  constructor(args) {
    super(args);
    this.state = {
    };
    if(this.props.user.authenticated) {
      this.props.signOut();
    }
    const {history} = this.props;
    history.push('/');
  }

  render() {
    return (
      <Container>
        <Col sm="6">
          <Label>
            Du bist ausgeloggt.
          </Label>
        </Col>
      </Container>
    );
  }
}

export default withRouter(Logout);



// WEBPACK FOOTER //
// ./src/Logout.js